import { ForgotPasswordForm } from '@/features/Auth';

const ForgotPasswordPage = () => <ForgotPasswordForm />;

export default ForgotPasswordPage;